import React from "react";
import { Link } from "react-router-dom";
import { Heart, ShoppingBag } from "lucide-react";
import { formatPrice, resolveImg } from "../lib/api";
import { useStore } from "../context/StoreContext";

const badgeColor = (b) =>
  b === "Оригинал" ? "bg-navy text-white"
  : b === "Налично" ? "bg-gold text-white"
  : "bg-ivory text-navy border border-gold";

export default function ProductCard({ product, testid }) {
  const { toggleWishlist, inWishlist, addToCart } = useStore();
  const img = resolveImg(product.images?.[0]) || "https://images.pexels.com/photos/1563016/pexels-photo-1563016.jpeg?auto=compress&cs=tinysrgb&w=800";
  const liked = inWishlist(product.id);
  const badge = product.badges?.[0];

  return (
    <div className="product-card group bg-white border border-stone" data-testid={testid || `product-card-${product.id}`}>
      <Link to={`/kartina/${product.slug || product.id}`} className="block relative overflow-hidden aspect-[4/5] bg-stone">
        <img src={img} alt={product.title} loading="lazy"
             className="product-img w-full h-full object-cover" />
        {badge && (
          <span className={`absolute top-3 left-3 text-[10px] uppercase tracking-wider px-2.5 py-1 ${badgeColor(badge)}`}>
            {badge}
          </span>
        )}
        <button
          onClick={(e) => { e.preventDefault(); toggleWishlist(product); }}
          className={`absolute top-3 right-3 w-9 h-9 flex items-center justify-center bg-white/90 rounded-full transition-colors ${liked ? "text-gold" : "text-navy"}`}
          data-testid={`wishlist-toggle-${product.id}`} aria-label="Любими">
          <Heart size={17} fill={liked ? "#C6A45C" : "none"} />
        </button>
      </Link>

      <div className="p-4">
        <Link to={`/kartina/${product.slug || product.id}`}>
          <h3 className="font-serif text-lg text-navy leading-snug line-clamp-1 group-hover:text-gold transition-colors">{product.title}</h3>
        </Link>
        <p className="text-xs text-charcoal/50 mt-1">
          {[product.size, product.technique].filter(Boolean).join(" · ") || product.category_label}
        </p>
        <div className="flex items-center justify-between mt-3">
          <span className="font-serif text-lg text-navy" data-testid={`product-price-${product.id}`}>{formatPrice(product.price)}</span>
          {product.in_stock === false && <span className="text-[11px] uppercase tracking-wide text-charcoal/40">Продадена</span>}
        </div>
        <button
          onClick={() => addToCart(product)}
          disabled={product.in_stock === false}
          className="buy-btn mt-3 w-full flex items-center justify-center gap-2 py-2.5 rounded-sm text-sm font-semibold uppercase tracking-wide disabled:opacity-40 disabled:cursor-not-allowed"
          data-testid={`quick-add-${product.id}`}>
          <ShoppingBag size={16} /> Купи
        </button>
        <Link to={`/kartina/${product.slug || product.id}`}
              className="block text-center mt-2 text-xs uppercase tracking-wide text-navy/70 hover:text-gold transition-colors"
              data-testid={`view-details-${product.id}`}>
          Виж детайли
        </Link>
      </div>
    </div>
  );
}
